import chipClasses from "@mui/material/Chip/chipClasses";
import avatarClasses from "@mui/material/Avatar/avatarClasses";
import { typographyResponsive } from "../../styles/utils/typography.module";
import { resolve } from "../../styles/utils/utils";
export const chipMinHeight = {
    small: 24,
    medium: 32,
};
const containedColor = (dt, path) => {
    const backgroundColor = resolve(dt.cta.contained.color.background, path);
    const textColor = resolve(dt.cta.contained.color.text, path);
    return {
        background: backgroundColor.default,
        [`.${chipClasses.icon}, .${chipClasses.deleteIcon}`]: {
            backgroundColor: textColor.default,
        },
        [`.${chipClasses.label}`]: {
            color: textColor.default,
        },
        [`&.${chipClasses.clickable}:hover, &[class]:is(.Pxl-demo-hover, [data-demostate=hover])`]: {
            background: backgroundColor.hover,
        },
        "&:focus-visible, &[class]:is(.Pxl-demo-focus, [data-demostate=focus])": {
            background: backgroundColor.focus,
            boxShadow: resolve(dt.state.focus, path),
        },
        "&.Pxl-demo-activated": {
            background: backgroundColor.active,
        },
        [`&.${chipClasses.clickable}:active, &[class]:is(.Pxl-demo-active, [data-demostate=active])`]: {
            background: backgroundColor.pressed,
            boxShadow: "none",
        },
    };
};
const outlinedColor = (dt, path) => {
    const backgroundColor = resolve(dt.cta.outlined.color.background, path);
    const textColor = resolve(dt.cta.outlined.color.text, path);
    const borderColor = resolve(dt.cta.outlined.color.border, path);
    return {
        borderColor: borderColor.default,
        background: "transparent",
        [`.${chipClasses.icon}`]: {
            backgroundColor: borderColor.default,
        },
        [`.${chipClasses.label}`]: {
            color: textColor.default,
        },
        [`.${chipClasses.deleteIcon}`]: {
            backgroundColor: borderColor.default,
        },
        [`&.${chipClasses.clickable}:hover, &[class]:is(.Pxl-demo-hover, [data-demostate=hover])`]: {
            borderColor: borderColor.hover,
            color: textColor.hover,
            background: backgroundColor.hover,
            [`.${chipClasses.icon}`]: {
                backgroundColor: borderColor.hover,
            },
            [`.${chipClasses.label}`]: {
                color: borderColor.hover,
            },
        },
        "&:focus-visible, &[class]:is(.Pxl-demo-focus, [data-demostate=focus])": {
            borderColor: borderColor.focus,
            color: textColor.focus,
            background: backgroundColor.focus,
            boxShadow: resolve(dt.state.focus, path),
            [`.${chipClasses.icon}`]: {
                backgroundColor: borderColor.focus,
            },
            [`.${chipClasses.label}`]: {
                color: borderColor.focus,
            },
        },
        "&.Pxl-demo-activated": {
            borderColor: borderColor.active,
            color: textColor.active,
            background: backgroundColor.active,
            [`.${chipClasses.icon}`]: {
                backgroundColor: borderColor.active,
            },
            [`.${chipClasses.label}`]: {
                color: borderColor.active,
            },
        },
        [`&.${chipClasses.clickable}:active, &[class]:is(.Pxl-demo-active, [data-demostate=active])`]: {
            borderColor: borderColor.pressed,
            color: textColor.pressed,
            background: backgroundColor.pressed,
            [`.${chipClasses.icon}`]: {
                backgroundColor: borderColor.pressed,
            },
            [`.${chipClasses.label}`]: {
                color: borderColor.pressed,
            },
        },
        [`&.${chipClasses.disabled}`]: {
            background: "transparent",
        },
    };
};
export const MuiChipTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, containedColor(dt, ["neutral"])), { alignItems: "center", borderRadius: dt.chip.shape.borderRadius, [`.${chipClasses.icon}, .${chipClasses.deleteIcon}, .${avatarClasses.root}`]: {
                    margin: 0,
                }, [`.${chipClasses.deleteIcon}:not(.Pxl-chip-iconRight)`]: {
                    cursor: "pointer",
                    opacity: dt.opacity.states.ghost,
                    "&:hover": {
                        opacity: 0.8,
                    },
                    "&:focus-visible": {
                        opacity: 0.8,
                    },
                }, ".MuiTouchRipple-root": {
                    display: "none !important",
                }, [`&.${chipClasses.disabled}`]: {
                    opacity: dt.opacity.states.disabled.content,
                    pointerEvents: "none",
                    boxShadow: "none",
                }, [`&.${chipClasses.colorPrimary}`]: containedColor(dt, ["primary"]), [`&.${chipClasses.colorSecondary}`]: containedColor(dt, ["secondary"]), [`&.${chipClasses.colorError}`]: containedColor(dt, ["signal", "error"]), [`&.${chipClasses.colorWarning}`]: containedColor(dt, ["signal", "warning"]), [`&.${chipClasses.colorSuccess}`]: containedColor(dt, ["signal", "success"]), [`&.${chipClasses.colorInfo}`]: containedColor(dt, ["signal", "info"]), "&.Pxl-inverted": containedColor(dt, ["inverted"]) }),
            label: {
                paddingLeft: 0,
                paddingRight: 0,
            },
            outlined: Object.assign(Object.assign({}, outlinedColor(dt, ["neutral"])), { border: `${dt.borderWidth.xSmall} solid ${dt.cta.outlined.color.border.neutral.default}`, color: dt.color.onSurface.variant, background: "transparent", [`.${chipClasses.label}`]: {
                    color: dt.color.onSurface.variant,
                }, [`.${chipClasses.icon}`]: {
                    backgroundColor: dt.color.onSurface.variant,
                }, [`&.${chipClasses.clickable}:hover`]: {
                    borderColor: dt.cta.outlined.color.border.neutral.hover,
                    color: dt.cta.outlined.color.text.neutral.hover,
                    background: dt.cta.outlined.color.background.neutral.hover,
                }, "&:focus-visible": {
                    borderColor: dt.cta.outlined.color.border.neutral.focus,
                    color: dt.cta.outlined.color.text.neutral.focus,
                    background: dt.cta.outlined.color.background.neutral.focus,
                }, [`&.${chipClasses.clickable}:active`]: {
                    borderColor: dt.cta.outlined.color.border.neutral.pressed,
                    color: dt.cta.outlined.color.text.neutral.pressed,
                    background: dt.cta.outlined.color.background.neutral.pressed,
                }, [`.${chipClasses.deleteIcon}`]: {
                    backgroundColor: dt.cta.outlined.color.text.neutral.default,
                }, [`&.${chipClasses.colorPrimary}`]: outlinedColor(dt, ["primary"]), [`&.${chipClasses.colorSecondary}`]: outlinedColor(dt, ["secondary"]), [`&.${chipClasses.colorError}`]: outlinedColor(dt, ["signal", "error"]), [`&.${chipClasses.colorWarning}`]: outlinedColor(dt, ["signal", "warning"]), [`&.${chipClasses.colorSuccess}`]: outlinedColor(dt, ["signal", "success"]), [`&.${chipClasses.colorInfo}`]: outlinedColor(dt, ["signal", "info"]), "&.Pxl-inverted": outlinedColor(dt, ["inverted"]) }),
            sizeMedium: Object.assign(Object.assign({}, typographyResponsive(dt, "button.medium")), { height: "unset", minHeight: `${chipMinHeight.medium}px`, paddingLeft: dt.space.inline.xSmall, paddingRight: dt.space.inline.xSmall, gap: dt.space.inline.xSmall3, [`&:has(.${chipClasses.icon})`]: {
                    paddingLeft: dt.space.inline.xSmall2,
                }, [`&:has(.${chipClasses.deleteIcon}:not(.Pxl-chip-iconRight))`]: {
                    paddingRight: dt.space.inline.xSmall3,
                }, "&:has(.Pxl-chip-iconRight)": {
                    paddingRight: dt.space.inline.xSmall2,
                }, [`.${avatarClasses.root}`]: {
                    width: dt.size.large,
                    height: dt.size.large,
                }, [`&:has(.${avatarClasses.root})`]: {
                    paddingLeft: dt.inline.xSmall,
                }, [`.${chipClasses.icon}, .Pxl-chip-iconRight`]: {
                    width: dt.icon.size.medium,
                    height: dt.icon.size.medium,
                }, [`.${chipClasses.deleteIcon}:not(.Pxl-chip-iconRight)`]: {
                    width: dt.size.large,
                    height: dt.size.large,
                } }),
            sizeSmall: Object.assign(Object.assign({}, typographyResponsive(dt, "button.small", {})), { height: "unset", minHeight: `${chipMinHeight.small}px`, paddingLeft: dt.inline.small, paddingRight: dt.inline.small, gap: dt.space.inline.xSmall4, [`&:has(.${chipClasses.icon})`]: {
                    paddingLeft: dt.space.inline.xSmall3,
                }, [`&:has(.${chipClasses.deleteIcon}:not(.Pxl-chip-iconRight))`]: {
                    paddingRight: dt.space.inline.xSmall4,
                }, "&:has(.Pxl-chip-iconRight)": {
                    paddingRight: dt.space.inline.xSmall3,
                }, [`.${avatarClasses.root}`]: {
                    width: dt.size.medium,
                    height: dt.size.medium,
                }, [`&:has(.${avatarClasses.root})`]: {
                    paddingLeft: dt.space.inline.xSmall4,
                }, [`.${chipClasses.icon}, .Pxl-chip-iconRight`]: {
                    width: dt.icon.size.small,
                    height: dt.icon.size.small,
                }, [`.${chipClasses.deleteIcon}:not(.Pxl-chip-iconRight)`]: {
                    width: dt.size.medium,
                    height: dt.size.medium,
                } }),
        },
    };
};
